/**
 * Unified Schedules API
 *
 * 统一调度管理 endpoints，支持系统任务和工作流调度。
 * 对应后端 /v1/admin/schedules/*
 */

import apiClient from './client';
import type {
  UnifiedScheduleResponse,
  CreateUnifiedScheduleRequest,
  UpdateUnifiedScheduleRequest,
  UnifiedScheduleListResponse,
  UnifiedScheduleActionResponse,
  UnifiedScheduleExecutionsResponse,
  UnifiedScheduleListParams,
} from '@/types/schedule';

export const schedulesApi = {
  /**
   * 获取调度列表，可按类型筛选
   */
  list: async (params?: UnifiedScheduleListParams): Promise<UnifiedScheduleListResponse> => {
    const response = await apiClient.get('/schedules', { params });
    return response.data;
  },

  /**
   * 获取单个调度详情
   */
  get: async (scheduleId: string): Promise<UnifiedScheduleResponse> => {
    const response = await apiClient.get(`/schedules/${scheduleId}`);
    return response.data;
  },

  /**
   * 创建新调度
   */
  create: async (data: CreateUnifiedScheduleRequest): Promise<UnifiedScheduleResponse> => {
    const response = await apiClient.post('/schedules', data);
    return response.data;
  },

  /**
   * 更新已有调度
   */
  update: async (scheduleId: string, data: UpdateUnifiedScheduleRequest): Promise<UnifiedScheduleResponse> => {
    const response = await apiClient.put(`/schedules/${scheduleId}`, data);
    return response.data;
  },

  /**
   * 删除调度（同时删除 Temporal schedule）
   */
  delete: async (scheduleId: string): Promise<UnifiedScheduleActionResponse> => {
    const response = await apiClient.delete(`/schedules/${scheduleId}`);
    return response.data;
  },

  /**
   * 切换调度启用/禁用状态
   */
  toggle: async (scheduleId: string): Promise<UnifiedScheduleResponse> => {
    const response = await apiClient.post(`/schedules/${scheduleId}/toggle`);
    return response.data;
  },

  /**
   * 手动触发一次调度执行
   */
  trigger: async (scheduleId: string): Promise<UnifiedScheduleActionResponse> => {
    const response = await apiClient.post(`/schedules/${scheduleId}/trigger`);
    return response.data;
  },

  /**
   * 获取调度的执行历史（来自 Temporal）
   */
  getExecutions: async (scheduleId: string): Promise<UnifiedScheduleExecutionsResponse> => {
    const response = await apiClient.get(`/schedules/${scheduleId}/executions`);
    return response.data;
  },
};
